import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BaseSearch } from 'src/app/models/base-search';
import { Observable } from 'rxjs';
import { Panel, Roles, ShipmentListingSearchEnum, ShipmentListingSearchEnum1, ShipmentStatusEnum, ShipmentStatusForFr } from 'src/app/enums';
import { ShipmentService } from 'src/app/services/shipment.service';
import { PagerService } from 'src/app/services/pager-service';
import { MatSort, Sort } from '@angular/material/sort';
import { debounceTime, distinctUntilChanged, switchMap, catchError, map, tap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PackageServices } from 'src/app/services/package.service';
import { CustomerService } from 'src/app/services/customer-service.service';
import { Shipments } from 'src/app/models/shipments';
import { PackageListingSearchEnum } from 'src/app/enums';
import { AutocompleteDTO } from 'src/app/models/autocomplete-dto';
import { DatePipe } from '@angular/common';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Franchisee } from 'src/app/models/franchisee';
import { FranchiseeService } from 'src/app/services/franchisee.service';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/core/authentication.service';
@Component({
  selector: 'app-shipments',
  templateUrl: './shipments.component.html',
  styleUrls: ['./shipments.component.css']
})
export class ShipmentsComponent implements OnInit {

  ShipmentStatusEnum = ShipmentStatusEnum;
  displayedColumns: string[] = ['Shipment ID', 'Shipment Date', 'Country', 'Overpack', 'Packages', 'Weight', 'Status'];
  shipmentId: string;
  shipmentDate: Date;
  status: string = '';
  dataSource: MatTableDataSource<Shipments> = new MatTableDataSource<Shipments>();
  data: Shipments[] = [];
  itemsPerPage: number;
  sortby: string = '';
  order: string = '';
  pageSize: number = 10;
  currentIndex: number = 1;
  page: any;
  pager: any = {};
  startIndex: number = 1;
  endIndex: number = this.pageSize;
  totalItems: any;
  baseSearch: BaseSearch<Shipments>;
  showdata: boolean = false;
  isLoadingResults = true;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean;
  searchKeyword: string;
  suggestions$: Observable<AutocompleteDTO[]>;
  shipmentListingStatusOptions = (Object.keys(ShipmentListingSearchEnum).filter(v => typeof ShipmentListingSearchEnum[v] === 'number') as string[]).sort();
  flag: number;
  franchiseeList: Franchisee[] = [];
  franchiseeId: any = '';
  currentUser = new User();
  isFranchiseeLogin: boolean = false;
  statusEnum: any[] = [];

  warehouseId : any;

  constructor(private api: ShipmentService, private franchiseeApi: FranchiseeService,
    private pagerService: PagerService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public authorization: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.franchiseeId = '';
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.warehouseId = this.currentUser.warehouseId;

    this.getFranchiseeList();    
    this.sortby = 'ModifiedDate';
    this.order = 'desc'
    if (this.checkIfFranchisee()) {
      this.sortby = 'ModifiedDate';
      this.order = 'desc'
      this.shipmentListingStatusOptions = Object.keys(ShipmentStatusForFr).filter(v => typeof ShipmentStatusForFr[v] === 'number') as string[];
    }
    
    for (var enumMember in ShipmentListingSearchEnum1) {
      if (!isNaN(parseInt(enumMember))) {
        this.statusEnum.push({ key: enumMember, value: ShipmentListingSearchEnum1[enumMember] });
        // Uncomment if you want log
        // console.log("enum member: ", value[enumMember]);
      }
    }
    
    this.statusEnum.sort((a,b)=>a.value > b.value ? 1 : -1);

    
    
    this.getShipmentCollections(this.currentIndex, this.pageSize, this.shipmentId, this.shipmentDate, this.status, this.franchiseeId, this.order, this.sortby);
  }

  checkIfFranchisee(): Boolean {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser.franchiseId && this.currentUser.panel == Panel.Franchise)
      return true;
    return false;
  }

  getShipmentCollections(currentPage: number, pageSize: number, shipmentId: string = '', shipmentDate: Date = null, status: string = '', franchiseeId: number, order: string, sortby: string = '') {
    this.isLoadingResults = true;
    if (this.checkIfFranchisee()) {
      franchiseeId = this.currentUser.franchiseId;
      this.isFranchiseeLogin = true;


      this.api.franchiseeShipmentsCollection(currentPage, pageSize, order, sortby, shipmentId, shipmentDate, status, franchiseeId).subscribe(data => {
        this.baseSearch = data["result"];
        this.setData(this.baseSearch);
        //Stop Loading screen
        this.isLoadingResults = false;
      }, err => {
        console.log(err);
        this.isLoadingResults = false;
      });
    }
    else {
      this.isFranchiseeLogin = false;
      this.sortby = 'shipmentDate';
      this.order = 'desc'
      this.api.getShipments(currentPage, pageSize, order, sortby, shipmentId, shipmentDate, status, franchiseeId).subscribe(data => {
        this.baseSearch = data["result"];
        this.setData(this.baseSearch);
        //Stop Loading screen
        this.isLoadingResults = false;
      }, err => {
        console.log(err);
        this.isLoadingResults = false;
      });
    }
  }

  setData(baseSearch: any) {
    this.data = baseSearch.values;
    this.dataSource = new MatTableDataSource(this.data);
    this.pager = this.pagerService.getPager(baseSearch == null ? 0 : baseSearch.rowCount, baseSearch == null ? 0 : baseSearch.currentPage, baseSearch == null ? this.pageSize : baseSearch.pageSize);
    this.totalItems = this.pager.totalItems;
    this.page = this.currentIndex;
    this.startIndex = this.pager.startIndex + 1;
    this.endIndex = this.pager.endIndex + 1;
  }

  getFranchiseeList() {
    this.franchiseeApi.getAllFranchisesByWarehouseId(this.warehouseId).subscribe(data => {
      if (data["result"]) {
        this.franchiseeList = data["result"];
        this.franchiseeList.sort((a,b)=>a.franchiseName.toLocaleLowerCase() > b.franchiseName.toLocaleLowerCase() ? 1 : -1);
      }
      this.isLoadingResults = false;
    }, err => {
      console.log(err);
      this.isLoadingResults = false;
    });
  }

  reset() {
    this.franchiseeId = '';
    this.shipmentId = '';
    this.shipmentDate = null;
    this.status = '';
    this.currentIndex = 1;
    this.getShipmentCollections(this.currentIndex, this.pageSize, this.shipmentId, this.shipmentDate, this.status, this.franchiseeId, this.order, this.sortby);
  }

  search() {
    this.currentIndex = 1;
    var pipe = new DatePipe('en-US');
    this.getShipmentCollections(this.currentIndex, this.pageSize, this.shipmentId, this.shipmentDate, this.status, this.franchiseeId, this.order, this.sortby);
  }

  changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }


  setPage(event: any) {
    this.isLoadingResults = true;
    this.currentIndex = event.page;
    this.getShipmentCollections(this.currentIndex, this.pageSize, this.shipmentId, this.shipmentDate, this.status, this.franchiseeId, this.order, this.sortby);
  }

  setPageSize(size: number) {
    this.pageSize = size;
    this.getShipmentCollections(this.currentIndex, this.pageSize, this.shipmentId, this.shipmentDate, this.status, this.franchiseeId, this.order, this.sortby);
  }

  onSortClick(event) {
    let target = event.currentTarget;
    if (target.children.length > 0 && this.flag == 0) {
      this.sortby = target.innerText.toLowerCase().replace(/\s/g, "");
      this.order = "desc";
      this.flag = 1;
    } else {
      this.sortby = target.innerText.toLowerCase().replace(/\s/g, "");
      this.order = "asc";
      this.flag = 0;
    }
    this.sortby = this.ApplyMapping(this.sortby)
    this.getShipmentCollections(this.currentIndex, this.pageSize, this.shipmentId, this.shipmentDate, this.status, this.franchiseeId, this.order, this.sortby);
  }

  ApplyMapping(arg) {
    arg = arg.toLowerCase().replace(/\s/g, "");
    switch (arg) {
      case 'shipmentid': arg = 'shipmentid'; break;
      case 'shipmentdate': arg = 'shipmentdate'; break;
      case 'closingtime': arg = 'closingtime'; break;
      case 'country': arg = 'country'; break;
      case 'overpack': arg = 'noofoverpacks'; break;
      case 'packages': arg = 'packagescount'; break;
      case 'weight': arg = 'weight'; break;
      case 'status': arg = 'Status'; break;
    }
    return arg;
  }

  DeleteShipment(shipmentId: number) {
    if (confirm("Are you sure you want to delete this shipment?\n\n ")) {
      this.isLoadingResults = true;
      this.api.deleteShipment(shipmentId).subscribe(res => {
        if (res["statusCode"] == 200) {
          this.toastr.success(res["message"], "Shipment");
          this.currentIndex = 1;
          this.getShipmentCollections(this.currentIndex, this.pageSize, this.shipmentId, this.shipmentDate, this.status, this.franchiseeId, this.order, this.sortby);
          return false;
        }
      }, (err) => {
        this.toastr.error(err["message"], "Shipment");
        console.log(err);
        this.isLoadingResults = false;
      }
      );
    }
  }

}
